import { observer } from 'mobx-react';
import { ActiveRaffles } from '../active-raffles';
import { FutureRaffles } from '../future-raffles';
import { Flex } from '@mantine/core';

export const RafflePreview = observer(() => {
  return (
    <Flex direction="column" gap="16px">
      <ActiveRaffles limit={1} grow showEmptyState={false} />
      <FutureRaffles limit={1} grow />
    </Flex>
  );
});
